export interface OrderRow {
  id: string;
  viewStatus: string;
  orderDate: string;
  orderNumber: string;
  orderType: string;
  orderStatus: string;
  proNumber: string;
  reference1: string;
  reference2: string;
  bolNumber: string;
}

export interface OrderTrackingApiItem {
  id: string;
  orderDate: string;
  orderNumber: string;
  orderType: string;
  orderStatus: string;
  proNumber: string;
  reference1: string;
  reference2: string;
  bolNumber: string;
}

export interface OrderStatusApiItem {
  id: string;
  statusLocation: string;
  zipCode: string;
  statusTime: string;
  statusDate: string;
  originalStatusDate?: string;
  statusNote: string;
  addedBy: string;
  orderType?: string;
  statusFromTime?: string;
  statusToTime?: string;
  orderStatusType: { id: string; name: string } | null;
}

export type OrderTrackingSearchKey =
  | "all"
  | "pro"
  | "dts"
  | "reference1"
  | "reference2"
  | "bol"
  | "address"
  | "telephone";

export const SEARCH_TYPES: { id: OrderTrackingSearchKey; label: string }[] = [
  { id: "all", label: "All" },
  { id: "pro", label: "Pro#" },
  { id: "dts", label: "DTS#" },
  { id: "bol", label: "BOL#" },
];
